import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, LOCALE_ID } from '@angular/core';
import { customFieldsBase } from '../custom-fields-base';

@Component({
    selector: 'app-custom-fields-switch-type',
    templateUrl: './custom-fields-switch-type.component.html',
    styleUrls: ['./custom-fields-switch-type.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomFieldsSwitchTypeComponent extends customFieldsBase {
    constructor(cdr: ChangeDetectorRef, @Inject(LOCALE_ID) localeId: string) {
        super(cdr, localeId);
    }
}
